// Español. Traducción completa de locales/en.js.
//
// Las claves son las mismas que en inglés y el orden también, para poder comparar
// los dos ficheros de un vistazo. Lo que falte aquí sale en inglés en pantalla, no
// en blanco, así que una traducción a medias se ve, no se rompe.

export default {
  // --- armazón -------------------------------------------------------------
  // La descripción que sale en Google y al pegar el enlace en un chat. Vive aquí y no escrita
  // en el HTML porque el HTML se genera por idioma en el build (ver tools/prerender-langs.mjs).
  'seo.description': 'El clásico de lanzar plátanos, reinventado y multijugador: artillería por turnos sobre un skyline de neón. Contra la CPU, en el mismo teclado o por código con un amigo. Gratis y en seis idiomas.',
  'app.tagline': 'El clásico de lanzar plátanos, reinventado y multijugador.',
  'app.footer': 'Creado por Mendo Network con amor y mucha nostalgia.',
  'ad.label': 'Publicidad',
  'ad.tag': 'PUBLICIDAD',
  'app.canvasLabel': 'Campo de batalla: horizonte de neón con dos gorilas lanzando plátanos',
  'app.language': 'IDIOMA',

  'title.start': '▶ JUGAR YA',
  'title.join': '▶ UNIRME',

  'menu.title': 'MENÚ PRINCIPAL',
  'menu.resume': '▶ VOLVER A LA PARTIDA',
  'menu.newMatch': '▶ NUEVA PARTIDA',
  'menu.play': '▶ NUEVA PARTIDA',
  'menu.characters': '🎨 PERSONAJE',
  'menu.leaderboards': '🏆 CLASIFICACIONES',
  'menu.back': '← VOLVER AL INICIO',
  'menu.awards': '🏆 LOGROS',

  'setup.title': 'PREPARAR PARTIDA',
  'setup.mode': 'MODO',
  'setup.players': 'JUGADORES',
  'setup.turn': 'TIEMPO DE TURNO',
  'setup.noLimit': 'SIN LÍMITE',
  'setup.target': 'RONDAS DE LA PARTIDA',
  'setup.onePlayer': '🤖 1 JUGADOR',
  'setup.twoPlayers': '👥 2 JUGADORES',
  'setup.back': '← ATRÁS',
  'setup.start': '▶ EMPEZAR PARTIDA',

  'pause.title': 'EN PAUSA',
  'pause.turn': 'LE TOCA A {name}',
  'pause.resume': '▶ CONTINUAR',
  'pause.restart': '↻ REINICIAR',
  'pause.setup': '🎮 AJUSTES',
  'pause.share': '🔗 INVITAR',
  'pause.home': '🚪 TERMINAR LA PARTIDA',
  'pause.menu': '⌂ VOLVER AL MENÚ PRINCIPAL',
  'pause.music': 'MÚSICA',
  'pause.fx': 'EFECTOS',
  'setup.against': 'EL OTRO LADO',
  'setup.againstCpu': '🤖 LA CPU',
  'setup.againstRandom': '🎲 RIVAL ALEATORIO',
  'pool.waiting': '{n} ESPERANDO',
  'pool.playing': '{n} JUGANDO · {w} ESPERANDO',
  'pool.none': 'AHORA MISMO NO HAY NADIE ESPERANDO',
  'pool.noserver': 'SIN SERVIDOR · SE JUGARÁ CONTRA LA CPU',
  'search.title': 'BUSCANDO RIVAL',
  'search.empty': 'LA COLA ESTÁ VACÍA · SE JUGARÁ CONTRA LA CPU',
  'search.seconds': '{n} s',
  'search.matched': 'HA LLEGADO {name}',
  'search.cpu': '🤖 JUGAR CONTRA LA CPU',
  'search.cancel': '✖ CANCELAR',
  'special.sheep.name': 'OVEJA',
  'special.sheep.hint': 'Salta sola y estalla.',
  'play.fireSheep': '🐑 ¡OVEJA!',
  'bubble.sheep': '¡BEEEE!',
  'char.you': 'TÚ',
  'char.rival': 'RIVAL',
  'hud.vsOnline': 'CONTRA {name}',
  'music.on': 'MÚSICA SÍ',
  'music.off': 'MÚSICA NO',
  'pause.button': 'Pausa',

  'results.over': 'FIN DE LA PARTIDA',
  'results.wins': 'GANA {name}',
  'results.rematch': '▶ REVANCHA',

  // --- cabecera y barra de juego -------------------------------------------
  'hud.vsCpu': 'CONTRA CPU',
  'hud.twoPlayer': '2 JUGADORES',
  'hud.firstTo': 'PRIMERO EN',
  'hud.round': 'RONDA {n}',
  'hud.noRound': 'RONDA —',
  'hud.p1': 'J1',
  'hud.p2': 'J2',
  'hud.cpu': 'CPU',
  'hud.wind': 'VIENTO',

  'play.angle': 'ÁNGULO',
  'play.power': 'FUERZA',

  'play.fire': 'LANZAR',
  'play.waiting': 'ESPERANDO OPONENTE',
  'play.fireBall': 'LANZAR PELOTA',
  'play.fireGrenade': 'LANZAR GRANADA',
  'play.fireLeap': 'SALTAR Y LANZAR',
  'play.fireShield': 'LEVANTAR ESCUDO',
  'play.fireSpring': 'SUBIRSE AL MUELLE',
  'play.fireMushroom': 'GUARDAR SETA',

  // --- el botón de especiales ----------------------------------------------
  'special.none': '✦ ESPECIAL: NINGUNO',
  'special.attack': '⚔ ATAQUE',
  'special.guard': '🛡 DEFENSA',
  'special.spent': '✦ ESPECIAL: AGOTADO',
  'special.locked': '✦ ESPECIAL: BLOQUEADO',
  'special.off': 'SIN ESPECIALES',
  'special.chosen': '✦ {name} × {n}',

  // --- paneles -------------------------------------------------------------
  'loadout.title': '🎒 EQUIPO',
  'loadout.note': 'Lo que llevas: lo que elijas es lo que hace tu próximo tiro, y una protección se levanta con el botón del escudo. (La tecla I abre esto.)',
  'intro.welcome': '{n} HABILIDADES LISTAS — ⚔ ATAQUE ELIGE UNA',
  'loadout.next': 'Se guarda para tu próximo turno.',
  'loadout.ults': 'ATAQUES ESPECIALES',
  'loadout.guards': 'DEFENSAS',
  'loadout.howto': 'Logro: {name}',
  'loadout.off': 'En este modo no hay ataques especiales ni defensas: CLASSIC es el juego original.',
  'announce.round': 'RONDA {n}',
  'announce.fight': '¡PELEA!',
  'announce.turn': 'TU TURNO — {name}',
  'splash.tapForMusic': 'TOCA PARA OÍR MÚSICA',
  'char.title': '🎨 PERSONAJES',
  'char.close': '✕ CERRAR',
  'char.save': '✓ GUARDAR',
  'char.note': 'Especies y accesorios. Un animal más ancho es un blanco más ancho, y un chistero es una cabeza un poco más grande: el dibujo es la caja de colisión.',
  'char.player1': 'JUGADOR 1',
  'char.player2': 'JUGADOR 2',
  'slot.hat': 'CABEZA',
  'slot.face': 'CARA',
  'slot.neck': 'CUELLO',

  'award.title': '🏆 LOGROS',
  'award.close': '✕ CERRAR',
  'award.progress': '🏆 LOGROS {n}/{total}',
  'award.rewardAntic': '+ GESTO {name}',
  'award.rewardSpecial': '+ ESPECIAL {name}',

  'rank.title': '🏆 CLASIFICACIONES',
  'rank.close': '✕ CERRAR',
  'rank.name': 'TU NICKNAME',
    'rank.namePlaceholder': 'Introduce aquí tu nick para jugar',
  'rank.online': 'EN LÍNEA — EL MEJOR PRIMERO',
  'rank.refresh': '↻ ACTUALIZAR',
  'rank.local': 'EN ESTA MÁQUINA',
  'rank.emptyLocal': 'Nada todavía. Termina una partida y aparecerá aquí.',
  'rank.emptyOnline': 'Todavía no hay nada en la tabla. Sé el primero.',
  'rank.checking': 'Consultando…',

  'share.close': 'CERRAR',
  'share.generate': 'INVITAR A PARTIDA',
  'share.placeholder': 'Tu código aparecerá aquí',
  'share.copied': 'Copiado. Pásalo a quien quieras invitar.',
  'join.placeholder': 'TENGO UN CÓDIGO',
  'join.title': 'UNIRME A PARTIDA',
  'join.label': 'Código de partida',

  'lang.title': 'IDIOMA',
  'lang.note': 'El inglés es el original. Todo lo demás es una traducción suya.',

  // --- códigos de partida --------------------------------------------------
  'code.noCode': 'Pega antes un código.',
  'code.tooLong': 'Eso es demasiado largo para ser un código de partida.',
  'code.notACode': 'Eso no parece un código de partida.',
  'code.version': 'Ese código es de otra versión.',
  'code.corrupt': 'Código corrupto.',
  'code.mode': 'Ese código nombra un modo que esta versión no tiene.',

  // --- la tabla compartida -------------------------------------------------
  'lb.checking': 'preguntando al servidor…',
  'lb.online': 'tabla compartida, en directo',
  'lb.noServer': 'aquí no hay servidor de clasificación',
  'lb.timeout': 'el servidor no respondió a tiempo',

  // --- lo que gritan los gorilas -------------------------------------------
  'bubble.fireInTheHole': '¡AL SUELO!',
  'bubble.leap': '¡VOY!',
  'bubble.uavOnline': 'DRON ENEMIGO EN EL AIRE',
  'bubble.headshot': '¡BOOM, A LA CABEZA!',
  'bubble.extraLife': '¡VIDA EXTRA!',
  'bubble.mushroomSaved': '¡LA SETA AGUANTÓ!',
  'bubble.boomerangBack': '¡HA VUELTO!',
  'bubble.boomerangLost': 'NO HA VUELTO',

  // --- el cartel tras una muerte -------------------------------------------
  'wasted.subtitle': 'Al viento le dan igual tus planes.',

  // --- el cielo ------------------------------------------------------------
  'banner.0': 'COME MÁS PLÁTANOS',
  'banner.1': '¡A LO MONO!',
  'banner.2': 'PLÁTANO A LA PRESIDENCIA',
  'banner.3': 'ESTA PANCARTA MIENTE',
  'banner.4': 'MÁNDAME PLÁTANOS',
  'banner.5': 'FALLASTE OTRA VEZ',
  'banner.6': 'ABRAZOS GRATIS',
  'banner.7': 'SOCORRO, ESTOY EN UN JUEGO',
  'banner.8': 'VICE CITY — A 4 MINUTOS',
  'banner.9': 'LEONIDA: LA OTRA FLORIDA',
  'banner.10': 'LLEGA EN 2027. SEGURAMENTE.',

  // --- la presentación -----------------------------------------------------
  'tip.0': 'CONSEJO: AL VIENTO LE DAN IGUAL TUS PLANES.',
  'tip.1': 'CONSEJO: LA PREVISIÓN NUNCA CUENTA CON EL VIENTO. ESA ES LA GRACIA.',
  'tip.2': 'CONSEJO: UN PLÁTANO QUE VUELVE A BAJAR SIGUE SIENDO UN PLÁTANO.',
  'tip.3': 'CONSEJO: UNA GRANADA NO NECESITA DARLE A NADIE.',
  'tip.4': 'CONSEJO: SI EL OTRO GORILA ESTÁ DORMIDO, DISPARA.',
  'tip.5': 'CONSEJO: ALGUIEN TIENE QUE LIMPIAR ESE HORIZONTE.',

  // --- especies ------------------------------------------------------------
  'species.gorilla': 'GORILA',
  'species.chimp': 'CHIMPANCÉ',
  'species.orangutan': 'ORANGUTÁN',
  'species.baboon': 'BABUINO',
  'species.panda': 'PANDA',
  'species.bear': 'OSO PARDO',
  'species.rhino': 'RINOCERONTE',
  'species.bonobo': 'BONOBO',
  'species.gibbon': 'GIBÓN',
  'species.mandrill': 'MANDRILL',
  'species.hippo': 'HIPOPÓTAMO',
  'species.duck': 'PATO',
  'species.frog': 'RANA',

  // --- accesorios ----------------------------------------------------------
  'accessory.cap': 'GORRA',
  'accessory.beanie': 'GORRO DE LANA',
  'accessory.tophat': 'CHISTERA',
  'accessory.crown': 'CORONA',
  'accessory.viking': 'CASCO VIKINGO',
  'accessory.bow': 'LAZO ROSA',
  'accessory.shades': 'GAFAS DE SOL',
  'accessory.patch': 'PARCHE',
  'accessory.scarf': 'BUFANDA',
  'accessory.bowtie': 'PICULINA',
  'accessory.chain': 'CADENA DE ORO',

  // --- gestos --------------------------------------------------------------
  'antic.scratch': 'SE RASCA',
  'antic.head': 'SE RASCA LA CABEZA',
  'antic.chest': 'GOLPES DE PECHO',
  'antic.wave': 'SALUDO',
  'antic.pick': 'SE HURGA LA NARIZ',
  'antic.shrug': 'SE ENCOGE DE HOMBROS',
  'antic.stretch': 'ESTIRAMIENTO',
  'antic.shake': 'SE SACUDE',
  'antic.clap': 'APLAUDE',
  'antic.flex': 'SACA MÚSCULO',

  // --- modos ---------------------------------------------------------------
  'mode.modern.name': 'MODERNO',
  'mode.modern.blurb': 'Especiales, gestos, cielo y logros.',
  'mode.classic.name': 'CLÁSICO',
  'mode.classic.blurb': 'Sin especiales, gestos, cielo ni logros.',
  'mode.demolition.name': 'DEMOLICIÓN',
  'mode.demolition.blurb': 'Cráteres que tumban una torre entera.',
  'mode.lunar.name': 'GRAVEDAD LUNAR',
  'mode.lunar.blurb': 'Un tercio del tirón.',
  'mode.weather.name': 'CLIMA',
  'mode.weather.blurb': 'Lluvia, nieve y rachas.',
  'mode.quake.name': 'TERREMOTO',
  'mode.quake.blurb': 'Los edificios suben y bajan bajo tus pies.',

  // --- especiales ----------------------------------------------------------
  'special.flare.name': 'RASTRO',
  'special.flare.hint': 'La previsión llega al doble.',
  'special.heavy.name': 'PLOMO',
  'special.heavy.hint': 'El viento casi no la desvía.',
  'special.fat.name': 'GORDA',
  'special.fat.hint': 'Cráter mucho mayor.',
  'special.lunar.name': 'LUNAR',
  'special.lunar.hint': 'Sin viento. Cráter enorme.',
  'special.grenade.name': 'GRANADA',
  'special.grenade.hint': 'Bota y estalla con mecha.',
  'special.drone.name': 'DRON',
  'special.drone.hint': 'Sobrevuela y marca al rival.',
  'special.leap.name': 'EL SALTO',
  'special.leap.hint': 'Salta al punto del rival.',
  'special.shield.name': 'ESCUDO',
  'special.shield.hint': 'Para un disparo rival.',
  'social.title': 'CUÉNTASELO A ALGUIEN',
  'social.whatsapp': 'Compartir en WhatsApp',
  'social.telegram': 'Compartir en Telegram',
  'social.facebook': 'Compartir en Facebook',
  'social.x': 'Compartir en X',
  'social.instagram': 'Enviar a Instagram — abre la hoja de compartir del móvil',
  'social.copy': 'Copiar el enlace',
  'toast.copied': '🔗 Enlace copiado',
  'toast.copyFailed': 'El navegador no me ha dejado copiarlo',
  'special.pick': 'ELIGE UNO',
  'special.spring.name': 'MUELLE',
  'special.spring.hint': 'Te subes y bailas encima.',
  'special.mushroom.name': 'SETA',
  'special.mushroom.hint': 'Encaja el golpe que te mata.',
  'toast.crateSpecial': '📦 {name} +1 — tuyo también la ronda siguiente',
  'toast.crateTheirs': '📦 {who} se lleva {name}',
  'toast.crateLife': '❤ VIDA EXTRA — aguantas un golpe más',
  'toast.crateLifeTheirs': '❤ {who} se lleva una vida extra',
  'toast.award': '🏆 ¡LOGRO! {names}',
  'setup.cpu': 'DIFICULTAD DE LA CPU',
  'setup.cpuEasy': 'FÁCIL',
  'setup.cpuNormal': 'NORMAL',
  'setup.cpuHard': 'DIFÍCIL',
  'rotate.title': 'GIRA EL MÓVIL',
    'rotate.body': 'La partida se juega en apaisado: pon el teléfono de lado para seguir.',
  'setup.duel': 'CÓMO JUGÁIS',
  'duel.code': '🔗 CADA UNO EN SU PC / MÓVIL',
  'duel.hotseat': '⌨️ MISMO ORDENADOR',
  'share.waiting': 'Mándale el código. Él te devuelve otro.',
  'share.invite': 'Copia el código y pásalo a quien quieras invitar.',
  'share.joined': 'Dentro. Juegas tú primero.',
  'share.roomOpen': 'La sala está abierta: con este código se entra y jugáis en directo, sin ir pasando códigos.',
  'share.roomBack': 'Tu rival está dentro.',
  'share.roomGone': 'Tu rival ha salido. La sala sigue abierta y su asiento queda libre.',
  'share.roomLost': 'Se ha caído la conexión. La partida sigue en este aparato.',
  'code.inviteLength': 'Un código de invitación tiene 8 caracteres, 4 y 4.',
  'code.inviteLetters': 'Ese código tiene un carácter que no vale.',
  'code.inviteCheck': 'Ese código no cuadra: repasa alguna letra.',
  'special.ball.name': 'LA PELOTA',
  'special.ball.hint': 'A veces sale pelota.',
  'special.boomerang.name': 'BUMERÁN',
  'special.boomerang.hint': 'Vuelve a tu mano y no gasta la carga.',
  'toast.ball': '{icon} ¡{name}!',
  'ball.basket': 'BALÓN DE BALONCESTO',
  'ball.football': 'BALÓN DE FÚTBOL',
  'ball.rugby': 'BALÓN DE RUGBY',
  'ball.tennis': 'PELOTA DE TENIS',

  // --- logros --------------------------------------------------------------
  'ach.first-blood.name': 'PRIMERA SANGRE',
  'ach.first-blood.hint': 'Acierta tu primer plátano.',
  'ach.round-won.name': 'RONDA GANADA',
  'ach.round-won.hint': 'Gana una ronda.',
  'ach.butterfingers.name': 'MANOS DE MANTEQUILLA',
  'ach.butterfingers.hint': 'Darte a ti mismo también cuenta.',
  'ach.sharpshooter.name': 'FRANCOTIRADOR',
  'ach.sharpshooter.hint': 'Encadena tres aciertos seguidos.',
  'ach.match-won.name': 'PARTIDA GANADA',
  'ach.match-won.hint': 'Gana una partida.',
  'ach.cpu-slayer.name': 'CAZADOR DE MÁQUINAS',
  'ach.cpu-slayer.hint': 'Gana una partida contra el CPU.',
  'ach.moon-shot.name': 'A LA LUNA',
  'ach.moon-shot.hint': 'Cruza un plátano por delante de la luna.',
  'ach.sky-watcher.name': 'MIRANDO AL CIELO',
  'ach.sky-watcher.hint': 'Pilla tres cosas distintas cruzando el cielo.',
  'ach.flawless.name': 'SIN UN RASGUÑO',
  'ach.flawless.hint': 'Gana una partida sin ceder una sola ronda.',
  'ach.veteran.name': 'VETERANO',
  'ach.veteran.hint': 'Gana tres partidas.',
  'ach.thrower.name': 'BRAZO DE FERIA',
  'ach.thrower.hint': 'Lanza 50 plátanos.',
  'ach.rounds-10.name': 'DIEZ RONDAS',
  'ach.rounds-10.hint': 'Gana diez rondas.',
  'ach.sharpshooter-plus.name': 'OJO DE HALCÓN',
  'ach.sharpshooter-plus.hint': 'Encadena seis aciertos seguidos.',
  'ach.moon-3.name': 'ASTROFÍSICO',
  'ach.moon-3.hint': 'Cruza un plátano por delante de la luna tres veces.',
  'ach.cpu-3.name': 'APAGAFUEGOS',
  'ach.cpu-3.hint': 'Gana tres partidas al CPU.',
  'ach.flawless-3.name': 'INTOCABLE',
  'ach.flawless-3.hint': 'Gana tres partidas sin ceder una ronda.',
  'ach.veteran-2.name': 'LEYENDA',
  'ach.veteran-2.hint': 'Gana cinco partidas.',
  'ach.scavenger.name': 'CARROÑERO',
  'ach.scavenger.hint': 'Abre cinco cajas.',
  'ach.wall.name': 'MURO',
  'ach.wall.hint': 'Levanta el escudo cinco veces.',
  'ach.arsenal.name': 'ARSENAL',
  'ach.arsenal.hint': 'Usa seis especiales distintos.',
  'ach.bare-handed.name': 'A MANO LIMPIA',
  'ach.bare-handed.hint': 'Gana una partida sin gastar nada.',
  'ach.room-won.name': 'EN DIRECTO',
  'ach.room-won.hint': 'Gana una partida en una sala.',
  'ach.room-3.name': 'VECINDARIO',
  'ach.room-3.hint': 'Gana tres partidas en salas.',
  'ach.by-mail.name': 'POR CORREO',
  'ach.by-mail.hint': 'Gana un duelo por código.',
  'ach.boomerang-back.name': 'EL RETORNO',
  'ach.boomerang-back.hint': 'Coge tu propio bumerán tres veces.',
};
